import { httpClientVendasCoreBff } from 'vendas-core/shared/services'
import { type WebhookItem } from 'webhooks/shared/entities'

import { useMutationRequest } from '~/ui/hooks/utils'

interface PostWebhookSettingVariables {
  url: string
  events: string[]
  retry: { maxAttempts: number; type: string }
  authentication?: { type: string; username?: string; password?: string }
  [key: string]: unknown
}

export function usePostWebhookSetting(paymentProfileId: string | undefined) {
  return useMutationRequest<WebhookItem, unknown, false, PostWebhookSettingVariables>(
    ['usePostWebhookSetting', paymentProfileId],
    data =>
      httpClientVendasCoreBff<WebhookItem>({
        url: `/v1/payment-profile/${paymentProfileId}/webhooks/settings`,
        method: 'POST',
        data
      })
  )
}
